export default __webpack_public_path__ + "static/media/bathtubbefore.85a9ff07.jpg";